import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { fetchBranchUsers } from "../../../slices/company/branchUserSlice";
import SetSalaryModal from "./setSalaryModal";
import { Link } from "react-router-dom";
import { customTableStyles } from "../../../utils/tableStylings";
import { Cog } from "lucide-react";

const SetSalary = () => {
  const dispatch = useDispatch();
  const { branchUsers, loading } = useSelector((state) => state.branchUsers);

  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    dispatch(fetchBranchUsers());
  }, [dispatch]);

  const handleView = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const columns = [
    {
      name: "Employee ID",
      selector: (row) => (
        <Link className="btn btn-outline-primary">#{row.emp_id}</Link>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Payroll Type",
      selector: (row) => row.payroll_type || "-", // Assuming payroll_type field exists
      sortable: true,
    },
    {
      name: "Salary",
      selector: (row) => row.salary || 0,
      sortable: true,
      right: true,
    },
    {
      name: "Net Salary",
      selector: (row) => row.net_salary || 0,
      sortable: true,
      right: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleView(row)}
        >
          <Cog />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="card" style={{ marginTop: "60px"}}>
      <div className="card-header">
        <h5 className="mb-0">Set Salary</h5>
      </div>
      <div className="card-body">
        <DataTable
          columns={columns}
          data={branchUsers || []}
          progressPending={loading}
          pagination
          highlightOnHover
          customStyles={customTableStyles}
          striped
        />
      </div>

      {showModal && (
        <SetSalaryModal
          show={showModal}
          onClose={() => setShowModal(false)}
          user={selectedUser}
        />
      )}
    </div>
  );
};

export default SetSalary;
